"use-strict";

class StickyAddCart extends HTMLElement {
    constructor() {
        super();
        this._stickyInitialized = false;
    }
    connectedCallback() {
        if (this._stickyInitialized) return;
        this._stickyInitialized = true;
        this.init();
    }
    init() {
        this.getHeightAddToCart();
        const btn_minimal = this.querySelector("minimal-button");
        if (btn_minimal) {
            this._stickyMinimalButton = btn_minimal;
            this._stickyMinimalHandler = this.toggle.bind(this);
            btn_minimal.addEventListener("click", this._stickyMinimalHandler, false);
        }
    }
    getHeightAddToCart() {
        const _this = this;
        this.main = this.closest(".sec__featured-product");
        if (!this.main) return;
        const primaryBtn = this.main.querySelector(".button-trigger__sticky");
        const footer = document.querySelector(".product-sticky-hide");

        if (!primaryBtn) return;
        const mobileQuery = window.matchMedia("(max-width: 767.98px)");
        const directionThreshold = 6;
        let directionAnchorY = window.scrollY || window.pageYOffset || 0;
        let scrollFrame = 0;

        const setVisible = function (visible) {
            _this.classList.toggle("show-sticky-cart", visible);
            _this.setAttribute("aria-hidden", String(mobileQuery.matches && !visible));
        };

        const isNearFooter = function () {
            if (!footer) return false;
            return footer.getBoundingClientRect().top < window.innerHeight - 100;
        };

        const isWithinProductInfo = function () {
            const productInfoRect = _this.main.getBoundingClientRect();
            return productInfoRect.bottom > 0 && productInfoRect.top < window.innerHeight;
        };

        const updateStickyCart = function (forceSync) {
            const scrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);

            if (isNearFooter()) {
                directionAnchorY = scrollY;
                setVisible(false);
                return;
            }

            // 移动端浏览产品信息模块期间始终显示；模块完全滚出视口后，
            // 才切换为“下滑隐藏、上滑显示”的方向控制。
            if (mobileQuery.matches && isWithinProductInfo()) {
                directionAnchorY = scrollY;
                setVisible(true);
                return;
            }

            if (scrollY < 50) {
                directionAnchorY = scrollY;
                setVisible(false);
                return;
            }

            // 桌面端保持原来的展示逻辑，只在移动端根据滚动方向切换。
            if (!mobileQuery.matches) {
                directionAnchorY = scrollY;
                setVisible(true);
                return;
            }

            // 页面恢复到中间位置或设备方向切换时，先同步为可用状态。
            if (forceSync) {
                directionAnchorY = scrollY;
                setVisible(true);
                return;
            }

            const delta = scrollY - directionAnchorY;
            if (Math.abs(delta) < directionThreshold) return;

            directionAnchorY = scrollY;
            setVisible(delta < 0);
        };

        this._stickyScrollHandler = function () {
            if (scrollFrame) return;
            scrollFrame = window.requestAnimationFrame(function () {
                scrollFrame = 0;
                updateStickyCart(false);
            });
        };
        this._stickyLoadHandler = function () {
            updateStickyCart(true);
        };
        this._stickyViewportHandler = function () {
            updateStickyCart(true);
        };
        this._stickyMediaQuery = mobileQuery;
        this._stickyCancelFrame = function () {
            if (!scrollFrame) return;
            window.cancelAnimationFrame(scrollFrame);
            scrollFrame = 0;
        };

        window.addEventListener("scroll", this._stickyScrollHandler, { passive: true });
        window.addEventListener("load", this._stickyLoadHandler);
        if (typeof mobileQuery.addEventListener === "function") {
            mobileQuery.addEventListener("change", this._stickyViewportHandler);
        } else if (typeof mobileQuery.addListener === "function") {
            mobileQuery.addListener(this._stickyViewportHandler);
        }

        updateStickyCart(true);
    }
    disconnectedCallback() {
        if (this._stickyMinimalButton && this._stickyMinimalHandler) {
            this._stickyMinimalButton.removeEventListener("click", this._stickyMinimalHandler, false);
        }
        window.removeEventListener("scroll", this._stickyScrollHandler);
        window.removeEventListener("load", this._stickyLoadHandler);
        if (this._stickyMediaQuery && typeof this._stickyMediaQuery.removeEventListener === "function") {
            this._stickyMediaQuery.removeEventListener("change", this._stickyViewportHandler);
        } else if (this._stickyMediaQuery && typeof this._stickyMediaQuery.removeListener === "function") {
            this._stickyMediaQuery.removeListener(this._stickyViewportHandler);
        }
        if (this._stickyCancelFrame) this._stickyCancelFrame();
        this._stickyMinimalButton = null;
        this._stickyMinimalHandler = null;
        this._stickyInitialized = false;
    }
    toggle(e) {
        const target = e.currentTarget;
        target.classList.toggle("opened");
        if (!target) return;
        const parent = target.closest("sticky-add-cart");
        if (!parent) return;
        const content = parent.querySelector(".content--expand");
        slideAnime({
            target: content,
            animeType: "slideToggle",
        });
    }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
    constructor() {
        super();
        this.sold = this.dataset.sold;
        this.hours = this.dataset.hours;
        this.message = this.dataset.message;
        this.init();
    }
    init() {
        if (this.message && this.sold && this.hours) {
            var message = "";
            message = this.message
                .replace("{{ sold }}", this.randomSelect(this.sold))
                .replace("{{ hours }}", this.randomSelect(this.hours));
            this.innerHTML += message;
        }
    }

    randomSelect(numbers) {
        const numberArray = numbers.split(",");
        const randomIndex = Math.floor(Math.random() * numberArray.length);
        const randomNumber = numberArray[randomIndex];
        return randomNumber;
    }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
    constructor() {
        super();
        this.min = this.dataset.min;
        this.max = this.dataset.max;
        this.interval = this.dataset.interval;
        this.message = this.dataset.message;
        this.init();
    }
    init() {
        if (this.message && this.max && this.min && this.interval) {
            this.handle();
            setInterval(() => {
                this.handle();
            }, this.interval * 1000);
        }
    }

    handle() {
        var message = "";
        message = this.message.replace(
            "[count]",
            this.randomSelect(parseInt(this.min), parseInt(this.max))
        );
        this.innerHTML = message;
    }

    randomSelect(min, max) {
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
    constructor() {
        super();
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.init();
        this.initFunction();
    }

    initFunction() {
        this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
            btn.addEventListener("click", this.onVariantChange.bind(this), false);
        });
    }

    onVariantChange(e) {
        e.preventDefault();
        const target = e.currentTarget;
        target.classList.toggle("active");
        this.handleWhenSwatchUpdate();
    }

    handleWhenSwatchUpdate() {
        this.updateOptions();
        const arrayItem = this.updateMasterId(this.variantData);
        this.handleMediaCompare(arrayItem);
    }

    handleMediaCompare(arrayItem) {
        if (!arrayItem) return;
        const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
        const compareColorContent = this.closest(".compare-colors__content");
        if (!compareColorContent) return;
        const compareItems = compareColorContent.querySelector(".compare__items");
        if (!compareItems) return;
        compareItems.innerHTML = html;
    }

    updateMasterId(variantData) {
        let arrayItem = [];
        this.options.forEach((option) => {
            const matchingVariant = variantData.find((variant) => {
                return variant.options.includes(option);
            });
            if (matchingVariant) {
                arrayItem.push(matchingVariant);
            }
        });
        return arrayItem;
    }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
    constructor() {
        super();
    }
    init() {
        this.call();
    }
    call() {
        if (this.recommendationsObserver || this.recommendationsRequest) return;

        const setState = (state) => {
            this.dataset.recommendationsState = state;
            if (state === "loading") {
                this.setAttribute("aria-busy", "true");
            } else {
                this.removeAttribute("aria-busy");
            }
        };

        const removeEmptyRecommendations = () => {
            const informationBlock = this.closest(
                ".product-info-block--complementary_products"
            );
            const heading = informationBlock?.querySelector(
                ".product-recommendations-heading"
            );
            if (heading) heading.remove();
            if (informationBlock) {
                informationBlock.hidden = true;
            } else {
                this.style.display = "none";
            }
            setState("empty");
        };

        const loadRecommendations = () => {
            if (this.recommendationsRequest) return;
            setState("loading");

            const requestRecommendations = (attempt = 0) =>
                fetch(this.dataset.url)
                .then((response) => {
                    if (!response.ok) {
                        const requestError = new Error(
                            `Product recommendations request failed: ${response.status}`
                        );
                        requestError.retryable =
                            response.status === 429 || response.status >= 500;
                        throw requestError;
                    }
                    return response.text();
                })
                .catch((error) => {
                    const isNetworkError = error instanceof TypeError;
                    const canRetry =
                        attempt === 0 && (isNetworkError || error.retryable === true);

                    if (!canRetry) throw error;

                    const retryDelay = 1200 + Math.floor(Math.random() * 300);
                    return new Promise((resolve) => {
                        this.recommendationsRetryTimer = window.setTimeout(() => {
                            this.recommendationsRetryTimer = null;
                            resolve(requestRecommendations(attempt + 1));
                        }, retryDelay);
                    });
                });

            this.recommendationsRequest = requestRecommendations()
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector(
                        "product-recommendations"
                    );
                    const recommendationsMarkup =
                        recommendations?.innerHTML?.trim() || "";

                    if (!recommendationsMarkup) {
                        removeEmptyRecommendations();
                        return;
                    }

                    this.innerHTML = recommendationsMarkup;
                    setState("loaded");

                    if (this.querySelector(".swiper-wrapper")) {
                        this.initSlide();
                        BlsAnimations.init();
                        BlsLazyloadImg.init();
                    }
                    initLazyloadItem();
                })
                .catch((error) => {
                    setState("error");
                    console.error(error);
                })
                .finally(() => {
                    this.recommendationsRequest = null;
                });
        };

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.recommendationsObserver = null;
            loadRecommendations();
        };

        if (!("IntersectionObserver" in window)) {
            loadRecommendations();
            return;
        }

        this.recommendationsObserver = new IntersectionObserver(
            handleIntersection.bind(this),
            { rootMargin: "0px 0px 400px 0px" }
        );
        this.recommendationsObserver.observe(this);
    }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
    constructor() {
        super();
        this.classList.remove("skeleton");
    }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        var group = this.querySelector('.productGroup[type="application/json"]');
        if (!group) return;
        var variantData = JSON.parse(group.innerText);
        var query = "";
        variantData.forEach((e, key, variantData) => {
            if (!Object.is(variantData.length - 1, key)) {
                query += e + "%20OR%20id:";
            } else {
                query += e;
            }
        });
        var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
        fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then(async (responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.innerHTML = html.querySelector(".product-group").innerHTML;
            })
            .catch((e) => {
                throw error;
            })
            .finally(() => {
                this.eventProductGroupAction();
            });
    }

    eventProductGroupAction() {
        document
            .querySelectorAll(".product-group-list .product-variant-option")
            .forEach((select) => {
                select.addEventListener(
                    "change",
                    (event) => {
                        var target = event.target;
                        var image =
                            target.options[target.selectedIndex].getAttribute("data-image"),
                            price =
                            target.options[target.selectedIndex].getAttribute("data-price"),
                            pro_handle = target.getAttribute("data-handle"),
                            image =
                            target.options[target.selectedIndex].getAttribute("data-image"),
                            price =
                            target.options[target.selectedIndex].getAttribute("data-price"),
                            pro_handle = target.getAttribute("data-handle"),
                            compare_price =
                            target.options[target.selectedIndex].getAttribute(
                                "data-compare-price"
                            );
                        var img = target
                            .closest(".product-group-list")
                            .querySelector(".product-group-item ." + pro_handle + "")
                            .querySelector("img");
                        if (img) {
                            img.removeAttribute("srcset");
                            img.setAttribute("src", image);
                        }
                        const productTarget = target.closest(".product-group-item");
                        const bls__price = productTarget.querySelector(
                            ".product-item__price .card-product-price"
                        );
                        if (bls__price) {
                            if (!bls__price.querySelector(".compare-price")) {
                                var ps = document.createElement("div");
                                var sp = document.createElement("span");
                                var cp = document.createElement("s");
                                cp.classList.add("price-item", "compare-price");
                                sp.appendChild(cp);
                                ps.appendChild(sp);
                                ps.classList.add("price-regular");
                                if (productTarget.querySelector(".card-product-price")) {
                                    productTarget
                                        .querySelector(".card-product-price")
                                        .appendChild(ps);
                                }
                            }
                            const cpp = bls__price.querySelector(".compare-price");

                            if (cpp) {
                                if (compare_price && compare_price > price) {
                                    const compare_format = Shopify.formatMoney(
                                        compare_price,
                                        themeGlobalVariables.settings.money_format
                                    );
                                    cpp.innerHTML = compare_format;
                                    if (bls__price.querySelector(".price-regular")) {
                                        bls__price
                                            .querySelector(".price-regular")
                                            .classList.add("primary-color");
                                    }
                                    if (bls__price.querySelector(".price-regular .price")) {
                                        bls__price
                                            .querySelector(".price-regular .price")
                                            .classList.add("price--special");
                                    }
                                } else {
                                    cpp.innerHTML = "";
                                    if (bls__price.querySelector(".price-regular")) {
                                        bls__price
                                            .querySelector(".price-regular")
                                            .classList.remove("primary-color");
                                    }
                                    if (bls__price.querySelector(".price-regular .price")) {
                                        bls__price.querySelector(
                                            ".price-regular .price"
                                        ).innerHTML = Shopify.formatMoney(
                                            price,
                                            cartStrings.money_format
                                        );
                                        bls__price
                                            .querySelector(".price-regular .price")
                                            .classList.remove("price--special");
                                    }
                                }
                            }
                        }
                        target.setAttribute("data-price", price);
                        target.setAttribute("data-compare-price", compare_price);
                    },
                    false
                );
            });

        let totalQty = 0;
        const classQty = document.querySelectorAll(
            ".quantity__input-product-group"
        );
        classQty.forEach((input) => {
            let valueQtyDefault = input.value;
            let valueAsDefault = parseFloat(valueQtyDefault);
            if (!isNaN(valueAsDefault)) {
                totalQty += valueAsDefault;
            }
            input.addEventListener("change", () => {
                totalQty = 0;
                classQty.forEach((value) => {
                    let valueQty = value.value;
                    let valueAsQty = parseFloat(valueQty);
                    if (!isNaN(valueAsQty)) {
                        totalQty += valueAsQty;
                    }
                });
            });
        });
        document.querySelectorAll(".product-group-submit").forEach((button) => {
            button.addEventListener(
                "click",
                (event) => {
                    if (totalQty === 0) {
                        const content = document.querySelector(
                            ".form-infor .add-cart-error"
                        );
                        const messageErrQty = button.getAttribute("data-add-cart-err-qty");
                        handleErrorMessagePopup(messageErrQty);
                        if (!content) return;
                    } else {
                        this.submitProductGroup(event);
                    }
                },
                false
            );
        });

        document.querySelectorAll(".product-group-buy-now").forEach((button) => {
            button.addEventListener(
                "click",
                (event) => {
                    if (totalQty === 0) {
                        const content = document.querySelector(
                            ".form-infor .add-cart-error"
                        );
                        const messageErrQty = button.getAttribute("data-add-cart-err-qty");
                        handleErrorMessagePopup(messageErrQty);
                        if (!content) return;
                    } else {
                        this.submitNowProductGroup(event);
                    }
                },
                false
            );
        });
    }

    submitNowProductGroup(event) {
        event.preventDefault();
        const form = document.getElementById("form-product-grouped");
        const config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(form);
        config.body = formData;
        fetch(`${routes.cart_add_url}.js`, config)
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                if (parsedState.items) {
                    if (typeof window.boyaOpenAITrackCheckoutStarted === "function") {
                        window.boyaOpenAITrackCheckoutStarted();
                    }
                    window.location.href = "/checkout";
                } else {
                    const content = document.querySelector(".form-infor .add-cart-error");
                    if (!content) return;
                }
            })
            .catch((e) => {
                throw e;
            });
    }

    submitProductGroup(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
        const form = document.getElementById("form-product-grouped");
        const config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        let openMiniCart = 0;
        const formData = new FormData(form);
        if (cart) {
            formData.append(
                "sections",
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        target.classList.add("loading");
        fetch(`${routes.cart_add_url}.js`, config)
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                fetch("/cart.json")
                    .then((res) => res.json())
                    .then((cart) => {
                        if (cart.item_count != undefined) {
                            document.querySelectorAll(".cart-count").forEach((el) => {
                                if (el.classList.contains("cart-count-drawer")) {
                                    el.innerHTML = `(${cart.item_count})`;
                                } else {
                                    el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                                }
                            });
                            if (document.querySelector("header-total-price")) {
                                document.querySelector("header-total-price").updateTotal(cart);
                            }
                            const cart_free_ship = document.querySelector(
                                "free-ship-progress-bar"
                            );
                            if (cart_free_ship) {
                                cart_free_ship.init(cart.items_subtotal_price);
                            }
                        }
                    })
                    .catch((error) => {
                        throw error;
                    });
                const parsedState = JSON.parse(state);
                if (parsedState.message) {
                    handleErrorMessagePopup(parsedState.description);
                    if (!content) return;
                } else {
                    parsedState.items.forEach((e) => {
                        if (e.quantity > 0) {
                            openMiniCart = 1;
                        }
                    });
                    cart.getSectionsToRender().forEach((section) => {
                        const elementToReplace = document.getElementById(section.id);
                        const html = new DOMParser().parseFromString(
                            parsedState.sections[section.id],
                            "text/html"
                        );
                        elementToReplace.innerHTML =
                            html.querySelector("#minicart-form").innerHTML;
                        const countdown = cart.querySelector(".cart-countdown-time");
                        const html_countdown = html.querySelector(".cart-countdown-time");
                        if (countdown && html_countdown) {
                            countdown.innerHTML = html_countdown.innerHTML;
                        }
                    });
                    cart.cartAction();
                }
            })
            .catch((e) => {
                throw e;
            })
            .finally(() => {
                target.classList.remove("loading");
                if (openMiniCart === 1) {
                    cart.open();
                }
                const cartRecommend = document.querySelector(".cart-recommend");
                if (
                    cartRecommend &&
                    !cartRecommend.classList.contains("hidden-recommend")
                ) {
                    if (cartRecommend.classList.contains('cart-recommend-custom')) {
                        const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
                        const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
                        if (cartUpsellItem.length > 0) {
                            setTimeout(function() {
                                cartRecommend.classList.add("open");
                            }, 800);
                        } else if (cartUpsellSlide.length === 0) {
                            cartRecommend.classList.remove('block');
                            cartRecommend.classList.add('hidden');
                        }
                    } else {
                        setTimeout(function() {
                            cartRecommend.classList.add("open");
                        }, 800);
                    }
                }
            });
    }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
    constructor() {
        super();
        this.productPopupDiv = this.querySelector(".product-addons__content");
        this.productPopupTemplate = this.querySelector("template[data-product-addons-template]");
        this.isSharedVariantPopup = this.hasAttribute("data-shared-variant-popup");
        this.activeVariantContainer = null;
        this.boundVariantSwiper = null;
        this.init();
    }
    init() {
        if (this.isSharedVariantPopup) return;
        if (this.productPopupDiv) {
            this.addEventListener("click", this.onClick.bind(this));
        }
    }
    onClick() {
        this.openPopup();
    }
    openPopup() {
        const html = this.productPopupDiv;
        if (!html) return;
        html.classList.remove("hidden");
        this.initPopup(
            html,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
        );
    }
    materializeSharedPopup() {
        if (this.productPopupDiv) return this.productPopupDiv;
        if (!this.productPopupTemplate) return null;

        const fragment = this.productPopupTemplate.content.cloneNode(true);
        const popup = fragment.querySelector(".product-addons__content");
        if (!popup) return null;

        this.appendChild(fragment);
        this.productPopupTemplate.remove();
        this.productPopupTemplate = null;
        this.productPopupDiv = popup;
        return popup;
    }
    openForVariant(index, id, trigger) {
        if (!this.isSharedVariantPopup || !Number.isInteger(index)) return;

        this.activeVariantContainer = trigger?.closest(".varriant-custom-list") ||
            this.closest(".varriant-custom-list");
        if (!this.materializeSharedPopup()) return;

        this.updateVariantSelection(index, id);
        this.hydrateVariantImage(index);
        this.openPopup();

        requestAnimationFrame(() => {
            this.initializeSharedCarousel(index);
        });
    }
    updateVariantSelection(index, id) {
        const variantContainer = this.activeVariantContainer;
        if (!variantContainer) return;

        const listItem = variantContainer.querySelector(`.list-item[data-index="${index}"]`);
        const radioInput = listItem?.querySelector('input[type="radio"]');
        if (radioInput) radioInput.checked = true;

        const sectionId = this.dataset.sectionId;
        const forms = sectionId ? [
            document.getElementById(`product-form-${sectionId}`),
            document.getElementById(`sticky-addcart-form-${sectionId}`)
        ] : [];
        const variantInputs = forms
            .filter(Boolean)
            .map((form) => form.querySelector('input[name="id"]'))
            .filter(Boolean);

        if (variantInputs.length === 0) {
            const productTarget = variantContainer.closest(".product__item-js");
            const fallbackInput = productTarget?.querySelector("input.product-variant-id");
            if (fallbackInput) variantInputs.push(fallbackInput);
        }

        if (id !== undefined && id !== null && id !== "") {
            variantInputs.forEach((input) => {
                input.value = id;
                input.disabled = false;
            });
        }

        const picker = variantContainer.closest(
            "variant-radios-detail, variant-group-detail, variant-radios-single"
        );
        if (typeof picker?.syncVariantDescriptions === "function") {
            picker.syncVariantDescriptions();
        }
    }
    hydrateDeferredImages(container) {
        if (!container) return;

        container.querySelectorAll("source[data-srcset]").forEach((source) => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute("data-srcset");
        });
        container.querySelectorAll("img[data-src], img[data-srcset]").forEach((image) => {
            image.loading = "eager";
            image.fetchPriority = "high";
            if (image.dataset.srcset) {
                image.srcset = image.dataset.srcset;
                image.removeAttribute("data-srcset");
            }
            if (image.dataset.src) {
                image.src = image.dataset.src;
                image.removeAttribute("data-src");
            }
        });
    }
    hydrateVariantImage(index) {
        if (!this.productPopupDiv) return;
        this.productPopupDiv
            .querySelectorAll(`.swiper-slide[data-index="${index}"]`)
            .forEach((slide) => this.hydrateDeferredImages(slide));
    }
    initializeSharedCarousel(index) {
        const swiperElement = this.productPopupDiv?.querySelector(".swiper-popup");
        if (!swiperElement) return;

        if (typeof swiperElement.initSlide === "function") {
            swiperElement.initSlide();
        }
        const swiper = swiperElement.swiper || swiperElement.globalSlide;
        if (!swiper) return;

        if (this.boundVariantSwiper !== swiper) {
            this.boundVariantSwiper = swiper;
            swiper.on("slideChange", () => {
                const activeSlide = swiper.slides?.[swiper.activeIndex];
                const newIndex = Number(activeSlide?.dataset.index ?? swiper.realIndex);
                if (!Number.isInteger(newIndex)) return;

                this.hydrateVariantImage(newIndex);
                this.updateVariantSelection(newIndex, activeSlide?.dataset.idVarriant);
            });
        }

        if (typeof swiper.update === "function") swiper.update();
        if (swiper.params?.loop && typeof swiper.slideToLoop === "function") {
            swiper.slideToLoop(index, 0, false);
        } else if (typeof swiper.slideTo === "function") {
            swiper.slideTo(index, 0, false);
        }
        this.hydrateVariantImage(index);
    }
}
customElements.define("product-addons", ProductAddons);

class ProductAddonsThumbnail extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", this.onClickThumbnail.bind(this));
    }

    onClickThumbnail() {
        const index = parseInt(this.dataset.variantId, 10);
        const id = this.dataset.idVarriant;
        if (isNaN(index)) {
            return;
        }
        const popup = document.getElementById(this.dataset.popupId) || this.closest("product-addons");
        if (typeof popup?.openForVariant === "function") {
            popup.openForVariant(index, id, this);
        }
    }
}

customElements.define("product-addons-thumbnail", ProductAddonsThumbnail);

class SwatchDropdown extends HTMLElement {
    constructor() {
        super();
        this.spanFor = this.dataset.spanFor;
        this.init();
    }
    init() {
        if (!this.spanFor) return;
        this.addEventListener("click", this.activeFilterSort.bind(this), false);
    }
    activeFilterSort() {
        if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
            this.querySelector(`#${this.spanFor}`).classList.remove("active");
        } else {
            this.querySelector(`#${this.spanFor}`).classList.add("active");
        }
    }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        const boughTogether = document.querySelector(
            '.productBoughTogether[type="application/json"]'
        );
        if (!boughTogether) return;
        const variantData = JSON.parse(boughTogether.innerText);
        let query = "";
        variantData.forEach((e, key, variantData) => {
            if (!Object.is(variantData.length - 1, key)) {
                query += e + "%20OR%20id:";
            } else {
                query += e;
            }
        });
        const productAjaxURL =
            "?q=id:" + query + "&section_id=product-bough-together";
        fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then(async (responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                document.getElementById("product-bought-together").innerHTML =
                    html.querySelector(".bought-together").innerHTML;
            })
            .catch((e) => {
                throw error;
            })
            .finally(() => {
                this.eventProductBoughTogetherAction();
            });
    }
    eventProductBoughTogetherAction() {
        var _this = this;
        document
            .querySelectorAll(".bought-together-checkbox")
            .forEach((checkbox) => {
                checkbox.addEventListener(
                    "change",
                    (event) => {
                        var target = event.target;
                        var total_price = 0,
                            total_compare_price = 0,
                            save_price = 0,
                            price,
                            compare_price,
                            pro_handle = event.target.getAttribute("data-handle");
                        var img = target
                            .closest("#product-bought-together")
                            .querySelector(".product-bought-image-item." + pro_handle + "");
                        if (target.checked) {
                            img.classList.add("select");
                            target
                                .closest(".product-bought-together-item")
                                .classList.add("select");
                            target
                                .closest(".product-bought-together-item")
                                .querySelector(".product-variant-option")
                                .removeAttribute("disabled");
                            target
                                .closest(".product-bought-together-item")
                                .querySelector(".quantity")
                                .removeAttribute("disabled");
                        } else {
                            img.classList.remove("select");
                            target
                                .closest(".product-bought-together-item")
                                .classList.remove("select");
                            target
                                .closest(".product-bought-together-item")
                                .querySelector(".product-variant-option")
                                .setAttribute("disabled", true);
                            target
                                .closest(".product-bought-together-item")
                                .querySelector(".quantity")
                                .setAttribute("disabled", true);
                        }
                        setTimeout(function() {
                            var bought_together_select = document.querySelectorAll(
                                ".product-bought-together-item.select"
                            );
                            bought_together_select.forEach((item) => {
                                var option = item.querySelector(".product-variant-option");
                                price = option.getAttribute("data-price");
                                compare_price = option.getAttribute("data-compare-price");
                                total_price = total_price + Number(price);
                                total_compare_price =
                                    total_compare_price + Number(compare_price);
                            });
                            save_price = total_compare_price - total_price;
                            _this.eventProductBoughTogetherUpdatePrice(
                                total_price,
                                total_compare_price,
                                save_price
                            );
                            if (bought_together_select.length <= 1) {
                                document
                                    .querySelector(".bought-together-submit")
                                    .setAttribute("disabled", true);
                            } else {
                                document
                                    .querySelector(".bought-together-submit")
                                    .removeAttribute("disabled");
                            }
                        }, 50);
                    },
                    false
                );
            });
        document
            .querySelectorAll("#product-bought-together .product-variant-option")
            .forEach((select) => {
                select.addEventListener(
                    "change",
                    (event) => {
                        var target = event.target;
                        var total_price = 0,
                            total_compare_price = 0,
                            save_price = 0,
                            image =
                            target.options[target.selectedIndex].getAttribute("data-image"),
                            price =
                            target.options[target.selectedIndex].getAttribute("data-price"),
                            pro_handle = target.getAttribute("data-handle"),
                            compare_price =
                            target.options[target.selectedIndex].getAttribute(
                                "data-compare-price"
                            );
                        var img = target
                            .closest("#product-bought-together")
                            .querySelector(".product-bought-image-item." + pro_handle + "")
                            .querySelector("img");
                        if (img) {
                            img.removeAttribute("srcset");
                            img.setAttribute("src", image);
                        }
                        const productTarget = target.closest(
                            ".product-bought-together-item"
                        );
                        const bls__price = productTarget.querySelector(
                            ".product-item__price .card-product-price"
                        );
                        if (bls__price) {
                            if (!bls__price.querySelector(".compare-price")) {
                                var ps = document.createElement("div");
                                var sp = document.createElement("span");
                                var cp = document.createElement("s");
                                cp.classList.add("price-item", "compare-price");
                                sp.appendChild(cp);
                                ps.appendChild(sp);
                                ps.classList.add("price-regular");
                                if (productTarget.querySelector(".card-product-price")) {
                                    productTarget
                                        .querySelector(".card-product-price")
                                        .appendChild(ps);
                                }
                            }
                            const cpp = bls__price.querySelector(".compare-price");

                            if (cpp) {
                                if (compare_price && compare_price > price) {
                                    const compare_format = Shopify.formatMoney(
                                        compare_price,
                                        themeGlobalVariables.settings.money_format
                                    );
                                    cpp.innerHTML = compare_format;
                                    if (bls__price.querySelector(".price-regular")) {
                                        bls__price
                                            .querySelector(".price-regular")
                                            .classList.add("primary-color");
                                    }
                                    if (bls__price.querySelector(".price-regular .price")) {
                                        bls__price
                                            .querySelector(".price-regular .price")
                                            .classList.add("price--special");
                                    }
                                } else {
                                    cpp.innerHTML = "";
                                    if (bls__price.querySelector(".price-regular")) {
                                        bls__price
                                            .querySelector(".price-regular")
                                            .classList.remove("primary-color");
                                    }
                                    if (bls__price.querySelector(".price-regular .price")) {
                                        bls__price.querySelector(
                                            ".price-regular .price"
                                        ).innerHTML = Shopify.formatMoney(
                                            price,
                                            cartStrings.money_format
                                        );
                                        bls__price
                                            .querySelector(".price-regular .price")
                                            .classList.remove("price--special");
                                    }
                                }
                            }
                        }
                        target.setAttribute("data-price", price);
                        target.setAttribute("data-compare-price", compare_price);
                        document
                            .querySelectorAll(".product-bought-together-item.select")
                            .forEach((item) => {
                                var option = item.querySelector(".product-variant-option");
                                price = option.getAttribute("data-price");
                                compare_price = option.getAttribute("data-compare-price");
                                total_price = total_price + Number(price);
                                total_compare_price =
                                    total_compare_price + Number(compare_price);
                            });
                        save_price = total_compare_price - total_price;
                        _this.eventProductBoughTogetherUpdatePrice(
                            total_price,
                            total_compare_price,
                            save_price
                        );
                    },
                    false
                );
            });

        document.querySelectorAll(".bought-together-submit").forEach((button) => {
            button.addEventListener(
                "click",
                this.submitBoughtTogether.bind(this),
                false
            );
        });
    }
    submitBoughtTogether(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
        const form = document.getElementById("bought-together-form");
        const config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(form);
        if (cart) {
            formData.append(
                "sections",
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        target.classList.add("loading");
        fetch(`${routes.cart_add_url}.js`, config)
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                fetch("/cart.json")
                    .then((res) => res.json())
                    .then((cart) => {
                        if (cart.item_count != undefined) {
                            document.querySelectorAll(".cart-count").forEach((el) => {
                                if (el.classList.contains("cart-count-drawer")) {
                                    el.innerHTML = `(${cart.item_count})`;
                                } else {
                                    el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                                }
                            });
                            if (document.querySelector("header-total-price")) {
                                document.querySelector("header-total-price").updateTotal(cart);
                            }
                            const cart_free_ship = document.querySelector(
                                "free-ship-progress-bar"
                            );
                            if (cart_free_ship) {
                                cart_free_ship.init(cart.items_subtotal_price);
                            }
                        }
                    })
                    .catch((error) => {
                        throw error;
                    });
                const parsedState = JSON.parse(state);
                cart.getSectionsToRender().forEach((section) => {
                    const elementToReplace = document.getElementById(section.id);
                    const html = new DOMParser().parseFromString(
                        parsedState.sections[section.id],
                        "text/html"
                    );
                    elementToReplace.innerHTML =
                        html.querySelector("#minicart-form").innerHTML;
                    const countdown = cart.querySelector(".cart-countdown-time");
                    const html_countdown = html.querySelector(".cart-countdown-time");
                    if (countdown && html_countdown) {
                        countdown.innerHTML = html_countdown.innerHTML;
                    }
                });
                cart.cartAction();
            })
            .catch((e) => {
                throw e;
            })
            .finally(() => {
                target.classList.remove("loading");
                cart.open();
                const cartRecommend = document.querySelector(".cart-recommend");
                if (
                    cartRecommend &&
                    !cartRecommend.classList.contains("hidden-recommend")
                ) {
                    if (cartRecommend.classList.contains('cart-recommend-custom')) {
                        const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
                        const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
                        if (cartUpsellItem.length > 0) {
                            setTimeout(function() {
                                cartRecommend.classList.add("open");
                            }, 800);
                        } else if (cartUpsellSlide.length === 0) {
                            cartRecommend.classList.remove('block');
                            cartRecommend.classList.add('hidden');
                        }
                    } else {
                        setTimeout(function() {
                            cartRecommend.classList.add("open");
                        }, 800);
                    }
                }
            });
    }

    eventProductBoughTogetherUpdatePrice(
        total_price,
        total_compare_price,
        save_price
    ) {
        var total = document.querySelector("#product-bought-together .box-total");
        if (total) {
            total.querySelector(".saved-price .price").innerHTML =
                Shopify.formatMoney(save_price, cartStrings.money_format);
            total.querySelector(".total-price .price__sale .price-item").innerHTML =
                Shopify.formatMoney(total_compare_price, cartStrings.money_format);
            total.querySelector(".total-price .price").innerHTML =
                Shopify.formatMoney(total_price, cartStrings.money_format);
            if (total_compare_price > total_price) {
                total.querySelector(".total-price").classList.add("price--on-sale");
                total
                    .querySelector(".total-price .price")
                    .classList.add("special-price");
            } else {
                total.querySelector(".total-price").classList.remove("price--on-sale");
                total
                    .querySelector(".total-price .price")
                    .classList.remove("special-price");
            }
            if (save_price > 1) {
                total.querySelector(".saved-price").classList.remove("hidden");
            } else {
                total.querySelector(".saved-price").classList.add("hidden");
            }
        }
    }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function() {
    function addProductEntry(productJson, storedProducts) {
        if (storedProducts === null) storedProducts = [];

        var currentProductID = productJson.id.toString();
        if (!storedProducts.includes(currentProductID)) {
            storedProducts.unshift(currentProductID);
            if (storedProducts.length > 25) {
                storedProducts.pop();
            }
            localStorage.setItem(
                "glozin__recently-viewed-products",
                JSON.stringify(storedProducts)
            );
        } else {
            const index = storedProducts.indexOf(currentProductID);
            if (index > -1) {
                storedProducts.splice(index, 1);
            }
            storedProducts.unshift(currentProductID);
            localStorage.setItem(
                "glozin__recently-viewed-products",
                JSON.stringify(storedProducts)
            );
        }
    }

    const prodData = document.querySelector("[data-product-json]");
    if (prodData != null) {
        var productJson = JSON.parse(prodData.innerHTML);
        var storedProducts = JSON.parse(
            localStorage.getItem("glozin__recently-viewed-products")
        );
        addProductEntry(productJson, storedProducts);
    }
});
var BlsDropDownProduct = (function() {
    var isBound = false;
    return {
        innit: function() {
            if (isBound) return;
            isBound = true;

            // Delegate only the legacy product dropdowns that actually contain
            // .select__selected. Other components also use .custom-select (for
            // example product comparison) and have their own controller.
            document.addEventListener("click", function(event) {
                const selected = event.target.closest(
                    ".custom-select .select__selected"
                );
                if (selected) {
                    const dropdown = selected.nextElementSibling;
                    if (dropdown) dropdown.classList.toggle("hidden");
                    return;
                }

                if (!event.target.closest(".custom-select")) {
                    document.querySelectorAll(".select__dropdown").forEach((item) => {
                        item.classList.add("hidden");
                    });
                }
            });
        },
    };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
    return {
        init: () => {
            const syncInputs = document.querySelectorAll(
                ".product-detail__buy-buttons input.quantity-input"
            );
            syncInputs.forEach((input) => {
                input.addEventListener("change", function() {
                    const value = this.value;
                    syncInputs.forEach((otherInput) => {
                        if (otherInput !== input) {
                            otherInput.value = value;
                        }
                    });
                });
            });
        },
    };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
    constructor() {
        super();
        this.globalSlide = null;
        this.init();
    }

    init() {
        if (document.body.classList.contains("index")) {
            let pos = window.pageYOffset;
            if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
                this.initSlide();
            } else {
                if (this.classList.contains("lazy-loading-swiper-before")) {
                    this.initSlide();
                } else {
                    this.classList.add("lazy-loading-swiper-after");
                }
            }
        } else {
            this.initSlide();
        }
    }

    initSlide() {
        const _this = this;
        if (window.BoyaSwiperUtils?.hasLiveInstance(_this, this.globalSlide)) {
            this.globalSlide = this.globalSlide || _this.swiper;
            return;
        }
        var autoplaying = _this?.dataset.autoplay === "true";
        const loopRequested = _this?.dataset.loop === "true";
        const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
        var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
        const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
        const direction = _this?.dataset.direction ?
            _this?.dataset.direction :
            "horizontal";
        var autoplaySpeed = _this?.dataset.autoplaySpeed ?
            _this?.dataset.autoplaySpeed * 1000 :
            3000;
        var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
        const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
        const row = _this?.dataset.row ? _this?.dataset.row : 1;
        var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
        const autoItem = _this?.dataset.itemMobile === "true";
        const arrowCenterimage = _this?.dataset.arrowCenterimage ?
            _this?.dataset.arrowCenterimage :
            0;
        spacing = Number(spacing);
        autoplaySpeed = Number(autoplaySpeed);
        speed = Number(speed);
        if (autoplaying) {
            autoplaying = {
                delay: autoplaySpeed
            };
        }
        if (!itemTablet) {
            if (itemDesktop < 2) {
                itemTablet = 1;
            } else if (itemDesktop < 3) {
                itemTablet = 2;
            } else {
                itemTablet = 3;
            }
        }
        const slidesPerGroup = Math.max(
            1,
            Number(_this?.dataset.slidesPerGroup) || 1
        );
        const gridRows = Math.max(1, Number(row) || 1);
        const loop = window.BoyaSwiperUtils.canLoop(_this, {
            requested: loopRequested,
            slidesPerView: [itemMobile, itemTablet, itemDesktop],
            slidesPerGroup: slidesPerGroup,
            gridRows: gridRows,
        });
        this.globalSlide = new Swiper(_this, {
            slidesPerView: autoItem ? "auto" : itemMobile,
            spaceBetween: spacing >= 15 ? 15 : spacing,
            autoplay: autoplaying,
            direction: direction,
            loop: loop,
            effect: effect,
            speed: speed,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            grid: {
                rows: row,
                fill: "row",
            },
            navigation: {
                nextEl: _this.querySelector(".swiper-button-next"),
                prevEl: _this.querySelector(".swiper-button-prev"),
            },
            pagination: {
                clickable: true,
                el: document.querySelector(".swiper-pagination-product-set"),
                type: "custom",
                renderCustom: function(swiper, current, total) {
                    return current + "/" + total;
                }
            },
            breakpoints: {
                768: {
                    slidesPerView: itemTablet,
                    spaceBetween: spacing >= 30 ? 30 : spacing,
                },
                1025: {
                    slidesPerView: itemDesktop,
                    spaceBetween: spacing,
                },
            },

            on: {
                init: function() {
                    if (arrowCenterimage) {
                        var items_slide = _this.querySelectorAll(
                            ".product-item__media--ratio"
                        );
                        if (items_slide.length != 0) {
                            var oH = [];
                            items_slide.forEach((e) => {
                                oH.push(e.offsetHeight / 2);
                            });
                            var max = Math.max(...oH);
                            var arrowsOffset = "--arrows-offset-top: " + max + "px";
                            if (_this.querySelectorAll(".swiper-arrow")) {
                                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                                    arrow.setAttribute("style", arrowsOffset);
                                });
                            }
                        }
                    }
                }
            },
        });
    }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);
